import { Button } from '@lfg/ui/components';
import { Stack } from '@mui/material';
import { useAccount } from 'wagmi';

import { ProjectStageEnum } from 'src/global/enums/project.enum';
import { colors } from 'src/global/styles/colors';
import { useGA } from 'src/hooks/useGA';

import { PrimaryButton } from '../Buttons/PrimaryButton';
import { Show } from '../Show';

interface NodeSaleActionButtonsProps {
  isSaving: boolean;
  isPublishing: boolean;
  isFormLoading?: boolean;
  handleSaveDraft: () => Promise<void>;
  deployProject: () => Promise<void>;
  status?: ProjectStageEnum;
}

export function NodeSaleActionButtons(props: NodeSaleActionButtonsProps) {
  const { isSaving, isPublishing, isFormLoading, deployProject, handleSaveDraft, status } = props;
  const { address } = useAccount();
  const { trackButtonClickEvent } = useGA();

  return (
    <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2} marginTop={3}>
      <Show when={status !== ProjectStageEnum.PRODUCTION}>
        <Button
          padding={'14px 32px'}
          borderRadius={'4px'}
          bgColor={colors.neutral06}
          isLoading={isSaving}
          disabled={isSaving || isPublishing || isFormLoading}
          onClick={() => {
            trackButtonClickEvent({ name: 'save_program_as_draft', address });
            handleSaveDraft();
          }}
          sx={{
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '20px',
            '&:hover': {
              backgroundColor: '#31343b',
            },
            '&:disabled': {
              opacity: 0.3,
            },
          }}>
          Save as Draft
        </Button>
        <PrimaryButton
          type='button'
          isLoading={isPublishing}
          disabled={isPublishing || isSaving || isFormLoading}
          onClick={() => {
            trackButtonClickEvent({ name: 'publish_program', address });
            deployProject();
          }}>
          Publish
        </PrimaryButton>
      </Show>
      <Show when={status === ProjectStageEnum.PRODUCTION}>
        <PrimaryButton
          type='submit'
          isLoading={isSaving}
          disabled={isPublishing || isSaving || isFormLoading}
          onClick={() => {
            trackButtonClickEvent({ name: 'save_program_prod', address });
            handleSaveDraft();
          }}>
          Save
        </PrimaryButton>
      </Show>
    </Stack>
  );
}
